export default "__VITE_ASSET__BZPX5r9W__"